export const PICKUP_STATUS_COLORS = {
  0: 'transparent',
  1: '#FFFAE5',
  2: '#FFCBB2',
  3: '#CFF3C8',
  4: '#C7D6E9',
  5: '#D1F2CF',
  6: '#FFA3B5',
};
